// The "Modify your subscription" HubSpot form (portal 4146755). modify_subscription_requests is a COMPANY property
// (objectTypeId 0-2), the rest are CONTACT properties (0-1); the checkbox value is HubSpot's internal option id for
// "Upgrade to Bill Automation". Read from the form's render definition and property definitions, 2026-10-08.
export const SUBSCRIPTION_FORM_URL = 'https://2gvnn.share.hsforms.com/2JsvSJiB9QAe1S6V8ddu2YA';
export const SUBSCRIPTION_FORM_SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/4146755/26cbd226-207d-4007-b54b-a57c75dbb660';
export const BILL_AUTOMATION_UPGRADE_FIELDS = [{
  objectTypeId: '0-2',
  name: 'modify_subscription_requests',
  value: 'Upgrade'
}, {
  objectTypeId: '0-1',
  name: 'upgrade__add_services',
  value: 'bBy7sJ1lDoZRAR1oMsvih'
}];

// The fields an "Upgrade now" request ticks for each plan (LB-6187). The form has no Plus or Autopilot option yet (read
// 2026-10-26), so both tick "Upgrade to Bill Automation" and the request names the plan in its page name. Once the
// form's owner adds the options, their ids go here.
export const TIER_UPGRADE_FIELDS = {
  Plus: BILL_AUTOMATION_UPGRADE_FIELDS,
  Autopilot: BILL_AUTOMATION_UPGRADE_FIELDS
};